<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		index
		:rows="rows"
		height="700px"
		selection
		:excel="isButton_(scrId, 'EX')"
		paging
		:pageArray="screen.pageArray"
		:pageUnit="pageUnit"
		:totalSize="totalSize"
	>
		<template v-slot:actionsLeft>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="square-plus" :onClick="addRow">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="file" :onClick="() => onClickButton('save')">{{
				getMessage_('SWCC000138')
			}}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="() => onClickButton('delete')">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/CommonCode/store/helpers';
import { commCdDescTable } from '@common/CommonCode/Content/Table/columns';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.commCdDescRows;
		},
		columns() {
			// TODO:
			return commCdDescTable.map(column => ({ ...column, label: this.getMessage_(column.msgKey) }));
		},
		totalSize() {
			const { totalSize } = this.commCdDescPagingInfo;
			return totalSize;
		},

		pageUnit() {
			const { pageUnit } = this.commCdDescPagingInfo;
			return pageUnit;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		addRow() {
			const selectedRows = this.$refs.table.getSelectedRows();
			const toggleRowSelection = this.$refs.table.getTable().toggleRowSelection;
			this.addCommCdDescRow_().then(addedRow => {
				selectedRows.push(addedRow);
				selectedRows.forEach(row => {
					toggleRowSelection(row);
				});
			});
			this.$refs.table.scrollBottom();
		},
		async onClickButton(action) {
			const selectedRows = this.$refs.table.getSelectedRows();
			if (!selectedRows || selectedRows.length === 0) {
				const errMsg = this.getMessage_(action === 'save' ? 'SWCC000434' : 'SWCC000418');
				this.$sf_toast({ type: 'error', message: errMsg, option: { duration: 3000 } });
				return;
			}
			const messageCode = {
				save: 'SWCC000501',
				delete: 'SWCC000108'
			}[action];
			const clickFn = {
				save: this.saveCommCdDescList,
				delete: this.deleteCommCdDescList
			}[action];
			await this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_(messageCode),
				buttons: [{ title: 'Confirm', clickFn }] //this.getMessage_('SWCC000203')
			});
		},
		async saveCommCdDescList() {
			const commCdDescList = this.$refs.table.getSelectedRows();
			const { commCdType, commCd } = this.commCdDescModal.selectedRow;
			const { currentPage, pageUnit } = this.commCdDescPagingInfo;
			this.$sf_toggleLoading(true);
			this.saveCommCdDescList_({ commCdType, commCd, commCdDescList })
				.then(({ code, message }) =>
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message
					})
				)
				.then(() => this.selectCommCdDescList_({ commCdType, commCd, currentPage, pageUnit }))
				.finally(() => this.$sf_toggleLoading(false));
		},
		deleteCommCdDescList() {
			const commCdDescList = this.$refs.table.getSelectedRows();
			const { commCdType, commCd } = this.commCdDescModal.selectedRow;
			const { currentPage, pageUnit } = this.commCdDescPagingInfo;
			this.$sf_toggleLoading(true);
			this.deleteCommCdDescList_({ commCdType, commCd, commCdDescList })
				.then(res => res && this.$sf_toast({ ...res, type: res.code === 0 ? 'ok' : 'error' }))
				.then(() => this.selectCommCdDescList_({ commCdType, commCd, currentPage, pageUnit }))
				.finally(() => this.$sf_toggleLoading(false));
		}
	}
};
</script>

<style>
.rcv_id_label {
	text-decoration: none !important;
}
.rcv_id_blue * {
	color: rgb(40, 40, 255);
	font-weight: bolder;
	cursor: pointer;
	text-decoration: underline;
}
.commonCode__pointerCell {
	cursor: pointer;
}
</style>
